import React from 'react';
import { Link } from 'react-router-dom';
import './Project.css';

const Project = ({ project }) => {

    const { name, description, image, liveSite } = project;

    return (
        <div className="project-card p-5 mt-10">
            <div className='h-[200px] overflow-hidden'>
                <img src={image} className="w-full" alt="" />
            </div>
            <h2>{name}</h2>
            <p className='project-description'>{description}</p>
            <div className='flex justify-between'>
                <Link to="/">
                    <button className="btn btn-accent">See Details</button>
                </Link>
                <Link to={liveSite} target="_blank">
                    <button className="btn btn-accent">Live Site</button>
                </Link>
            </div>
        </div>
    );
};

export default Project;